import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, withCtx as _withCtx, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createTextVNode as _createTextVNode, createCommentVNode as _createCommentVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode } from "vue"

const _hoisted_1 = /*#__PURE__*/_createTextVNode("按月")
const _hoisted_2 = /*#__PURE__*/_createTextVNode("分段")
const _hoisted_3 = /*#__PURE__*/_createTextVNode("一次性")
const _hoisted_4 = /*#__PURE__*/_createTextVNode("其他")
const _hoisted_5 = { style: {"padding":"0 10px"} }
const _hoisted_6 = {
  key: 0,
  style: {"margin-bottom":"20px","text-align":"right"}
}
const _hoisted_7 = /*#__PURE__*/_createTextVNode("添加付款条件")
const _hoisted_8 = /*#__PURE__*/_createTextVNode("删除")

import { h, reactive, ref, PropType, watch, unref, nextTick } from 'vue';
import { ElMessage, ElMessageBox, ElForm, FormRules } from 'element-plus';
import moment from 'moment';

/* 辅助类 */
import { propTypes } from '@/utils/propTypes';
import { RmbcCpital, findIndex } from '@/utils/index';

/* Stores */
import { useCurrencyStore } from '@/store/currency';

/* 自定义组件 */
import { GbTables } from '@/components/GbTables';
import PayplanDialog from '@/views/payplans/compoments/PayPlanWriter.vue';

/* types */
import { ContractDetail } from '@/apis/contract/contract.type';
import { PayPlanList, CtAmount } from '@/apis/PayPlans/payplan.type';
import { TableColumn } from '@/components/GbTables/GbTablesTypes';
import { PlanAddRes } from '../../payplans/compoments/payplan.data';
import { GetPayplanConfigApi } from '@/apis/contract/draft.api';


export default /*#__PURE__*/_defineComponent({
  props: {
	isPreviews: propTypes.bool.def(false),
},
  emits: ['update', 'update:currency', 'blur'],
  setup(__props, { expose, emit: emits }) {

const props = __props



const currency = useCurrencyStore();


const contractId = ref<string>('');

const planDialogRef = ref<ComponentRef<typeof PayplanDialog>>();
const schema = ref<CtAmount>({ contract_amount: 0, currency: 'RMB', payment: 'F', plan_list: [] });

const scaleFormatter = (_: Recordable, __: TableColumn, cellValue: number) => {
	return h('span', `${cellValue}%`);
};

const tabColumns = reactive<TableColumn[]>([
	{ field: 'name', label: '款项名称', columnWidth: '150' },
	{ field: 'pay_condition', label: '款项条件' },
	{ field: 'scale', label: '款项比例', columnWidth: '80', align: 'right', formatter: scaleFormatter },
	{ field: 'amount', label: '款项金额', columnWidth: '120', align: 'right' },
	{ field: 'pay_date', label: '计划付款日期', columnWidth: '100', align: 'center' },
	{ field: 'remark', label: '备注', columnWidth: '150', align: 'left' },
]);

/* 表单验证规则 */
const formRules = reactive<FormRules>({
	contract_amount: [
		{ required: true, message: '合同金额不能为空', trigger: 'blur' },
		{ type: 'number', message: '合同金额必须是数值' },
	],
	payment: [{ required: true, message: '未选择合同付款类型', trigger: 'blur' }],
});

const acionts = {
	opAddSave: (data: any) => {
		schema.value.plan_list.push(data);
	},
	addPlan: () => {
		const planList = unref(schema).plan_list || [];
		const ctAmount = unref(schema).contract_amount || 0.0;
		const payType = unref(schema).payment;

		unref(planDialogRef)?.addPayPlan(ctAmount, planList, payType);
	},
	delPlan: (plan: any) => {
		const rowIndex = findIndex<PayPlanList>(schema.value.plan_list, (t: any) => {
			return t.id == plan.id;
		});
		if (rowIndex < 0) return;

		ElMessageBox.confirm('是否删除选中的数据？', '提示', { lockScroll: false, confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
			schema.value.plan_list.splice(rowIndex, 1);
		});
	},
	editPlan: (row: any) => {},
};

/* 修改付款计划 */
const editPayPlan = (row: PayPlanList) => {
	// showDialog.value = true;
	// dialogTitle.value = '付款计划编辑';
	// const planList = (amountSchema.value.plan_list || []).filter((item: any) => {
	// 	return item.id != row.id;
	// });
	// /* 遇事不决，nextTick */
	// nextTick(() => {
	// 	const methods = unref(planAddRef)?.methods;
	// 	const paymentType = unref(amountSchema).payment;
	// 	const { amount, scalc } = calcAmtTotal(planList);
	// 	methods?.setPayplanAmt(amount, scalc, paymentType);
	// 	methods?.setFormData(row);
	// });
};

watch(
	() => props.isPreviews,
	(isPreview) => {
		if (!isPreview) {
			tabColumns.push({ field: 'action', width: '120px', label: '操作', fixed: 'right', align: 'center' });
		}
	},
	{ deep: true, immediate: true }
);

/* 金额大写 */
watch(
	() => schema.value.contract_amount,
	(amount: number) => {
		schema.value.amount_big = RmbcCpital(amount);
	}
);

/* 付款方式 */
watch(
	() => unref(schema).payment,
	(newVal: string, oldVal: string) => {
		if (!props.isPreviews) {
			const msg = '已设置付款计划的情况下，更改付款方式会清空已设置的付款计划，是否继续？';
			const planList = schema.value.plan_list || [];
			if (planList && planList.length > 0) {
				ElMessageBox.confirm(msg, '警告', { lockScroll: false, confirmButtonText: '确定', cancelButtonText: '取消', type: 'warning' }).then(() => {
					schema.value.plan_list = [];
				});
			}
		}
	}
);

/* 金额输入控件 */
const onAmountInput = (val: any) => {
	emits('update', val);
};

const onAmountBlur = (val: any) => {
	emits('blur');
};

/* 选择币种 */
const onCurrencySelect = (val: string) => {
	emits('update:currency', val);
};

const methods = {
	setDatas: (data: ContractDetail) => {
		contractId.value = data.id || '';

		unref(schema).contract_amount = data.contract_amount;
		unref(schema).currency = data.currency;
		unref(schema).payment = data.payment;
		unref(schema).plan_list = data.payplanList;
	},

	/* 清除表单数据 */
	clearData: () => {
		unref(schema).contract_amount = 0.0;
		unref(schema).currency = 'RMB';
		unref(schema).plan_list = [];
	},
};

expose({ schema, methods });

return (_ctx: any,_cache: any) => {
  const _component_el_input_number = _resolveComponent("el-input-number")!
  const _component_el_form_item = _resolveComponent("el-form-item")!
  const _component_el_col = _resolveComponent("el-col")!
  const _component_el_option = _resolveComponent("el-option")!
  const _component_el_select = _resolveComponent("el-select")!
  const _component_el_row = _resolveComponent("el-row")!
  const _component_el_input = _resolveComponent("el-input")!
  const _component_el_radio_button = _resolveComponent("el-radio-button")!
  const _component_el_radio_group = _resolveComponent("el-radio-group")!
  const _component_ElButton = _resolveComponent("ElButton")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createVNode(_unref(ElForm), {
      model: schema.value,
      "label-width": "120px",
      "label-position": 'top',
      rules: _unref(formRules),
      disabled: props.isPreviews,
      style: {"padding":"20px 40px"}
    }, {
      default: _withCtx(() => [
        _createVNode(_component_el_row, { gutter: 20 }, {
          default: _withCtx(() => [
            _createVNode(_component_el_col, { span: 12 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_row, { gutter: 20 }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "合同总额",
                          prop: "contract_amount"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_input_number, {
                              class: "voa-sp",
                              modelValue: schema.value.contract_amount,
                              "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((schema.value.contract_amount) = $event)),
                              min: "0",
                              max: 999999999,
                              controls: false,
                              precision: 2,
                              style: {"width":"100%"},
                              onInput: onAmountInput,
                              onBlur: onAmountBlur
                            }, null, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }),
                    _createVNode(_component_el_col, { span: 12 }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_form_item, {
                          label: "币种",
                          prop: "currency"
                        }, {
                          default: _withCtx(() => [
                            _createVNode(_component_el_select, {
                              style: {"width":"100%"},
                              modelValue: schema.value.currency,
                              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((schema.value.currency) = $event)),
                              onChange: onCurrencySelect
                            }, {
                              default: _withCtx(() => [
                                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_unref(currency).getList, (category) => {
                                  return (_openBlock(), _createBlock(_component_el_option, {
                                    label: category.name,
                                    value: category.value
                                  }, null, 8, ["label", "value"]))
                                }), 256))
                              ]),
                              _: 1
                            }, 8, ["modelValue"])
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    })
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, { label: "金额大写" }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_input, {
                      modelValue: schema.value.amount_big,
                      "onUpdate:modelValue": _cache[2] || (_cache[2] = ($event: any) => ((schema.value.amount_big) = $event)),
                      disabled: "",
                      placeholder: "金额大写"
                    }, null, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            }),
            _createVNode(_component_el_col, { span: 6 }, {
              default: _withCtx(() => [
                _createVNode(_component_el_form_item, {
                  label: "支付方式",
                  prop: "payment"
                }, {
                  default: _withCtx(() => [
                    _createVNode(_component_el_radio_group, {
                      modelValue: schema.value.payment,
                      "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((schema.value.payment) = $event))
                    }, {
                      default: _withCtx(() => [
                        _createVNode(_component_el_radio_button, { label: "M" }, {
                          default: _withCtx(() => [
                            _hoisted_1
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio_button, { label: "F" }, {
                          default: _withCtx(() => [
                            _hoisted_2
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio_button, { label: "Y" }, {
                          default: _withCtx(() => [
                            _hoisted_3
                          ]),
                          _: 1
                        }),
                        _createVNode(_component_el_radio_button, { label: "QT" }, {
                          default: _withCtx(() => [
                            _hoisted_4
                          ]),
                          _: 1
                        })
                      ]),
                      _: 1
                    }, 8, ["modelValue"])
                  ]),
                  _: 1
                })
              ]),
              _: 1
            })
          ]),
          _: 1
        })
      ]),
      _: 1
    }, 8, ["model", "rules", "disabled"]),
    _createElementVNode("div", _hoisted_5, [
      (!props.isPreviews)
        ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
            _createVNode(_component_ElButton, {
              type: "primary",
              onClick: acionts.addPlan
            }, {
              default: _withCtx(() => [
                _hoisted_7
              ]),
              _: 1
            }, 8, ["onClick"])
          ]))
        : _createCommentVNode("", true),
      _createVNode(_unref(GbTables), {
        ref: "gbTablesRef",
        columns: _unref(tabColumns),
        data: schema.value.plan_list,
        showPaged: false,
        selection: false
      }, {
        pay_date: _withCtx(({ row }) => [
          _createElementVNode("span", null, _toDisplayString(row.pay_date ? _unref(moment)(row.pay_date).format('YYYY-MM-DD') : '--'), 1)
        ]),
        amount: _withCtx(({ row }) => [
          _createElementVNode("span", null, _toDisplayString(row.amount.toLocaleString('zh')), 1)
        ]),
        action: _withCtx(({ row }) => [
          _createVNode(_component_ElButton, {
            type: "danger",
            link: "",
            onClick: ($event: any) => (acionts.delPlan(row))
          }, {
            default: _withCtx(() => [
              _hoisted_8
            ]),
            _: 2
          }, 1032, ["onClick"])
        ]),
        _: 1
      }, 8, ["columns", "data"])
    ]),
    _createVNode(PayplanDialog, {
      ref_key: "planDialogRef",
      ref: planDialogRef,
      ctAmounts: schema.value.contract_amount,
      "onUpdate:ctAmounts": _cache[4] || (_cache[4] = ($event: any) => ((schema.value.contract_amount) = $event)),
      onOnAdd: acionts.opAddSave
    }, null, 8, ["ctAmounts", "onOnAdd"])
  ], 64))
}
}

})